import mod from "-!./Alert.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Alert.js?vue&type=script&lang=js&"